import { useEffect as l } from "react";
const f = (c, o, n) => (l(() => {
  window.scrollTo(0, 0);
}, [c]), l(() => {
  if (o.slice(1)) {
    const e = document.getElementById(o.slice(1)), t = e ? e.offsetTop : 0;
    window && t && window.scroll({
      top: t
    });
  }
}, [o, n]), null);
export {
  f as default
};
